import { render } from "./SortDialog.vue?vue&type=template&id=2f2011ac"
import script from "./SortDialog.vue?vue&type=script&lang=js"
export * from "./SortDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__